import {CustomFilterProps} from 'ag-grid-react';
import {Search} from 'platform/components';

export function QuickFilter(props: CustomFilterProps) {
  return <Search value={props.model} onChange={props.onModelChange} />;
}
